import styled from 'styled-components/macro';

const FakeInput = styled.span`
  display: block;
  position: relative;
  width: 22px;
  height: 22px;
  border: 1px solid var(--primary);
  background: var(--white);
  margin-right: 14px;
  border-radius: 5px;
`;

export default FakeInput;
